import type { JSONContent } from '@tiptap/core';

export const extractTextFromNode = (node: JSONContent): string => {
  if (node.type === 'text') {
    return node.text || '';
  }

  if (node.content && Array.isArray(node.content)) {
    const parts = node.content.map(extractTextFromNode);
    if (node.type === 'paragraph' || node.type === 'heading') {
      return parts.join('') + '\n';
    }
    if (node.type === 'hardBreak') {
      return '\n';
    }
    return parts.join('');
  }

  return '';
};
